import { Component, computed, DestroyRef, effect, inject, Input, OnDestroy, untracked } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientIdServiceService } from '@/services/app/client-id.service';
import { ClientService } from '@/services/api/client.service';
import { OfficesService } from '@/services/api/franchises.service';
import { SelectModule } from 'primeng/select';
import { Franchise } from '@/models/franchise.model';
import { FormsModule } from '@angular/forms';
import { DealsService } from '@/services/app/deals.service';
import { HsDeal } from '@/models/hs-contact';
import { PlanFilterService } from '../plan-browser/plan-filter.service';
import { DialogModule } from 'primeng/dialog';
import { PlanFilterComponent } from '../plan-browser/plan-filter.component';
import { PlanBrowserComponent } from '../plan-browser/plan-browser.component';
import { HigharcPlanService } from '@/services/api/higharc-plan.service';
import { HigharcPlan } from '@/models/higharc-plan.model';
import { PlansService } from '@/services/api/plans.service';
import { OfficeTemplatesService } from '../operations/assemblies/office-templates/services/office-templates.service';
import { StandardTemplate } from '@/models/standard-template.model';
import { BinderService } from '@/services/api/binder.service';
import { PlanBadgeComponent } from '@/global/plan-badge.component';
import { Plan } from '@/models/plan.model';
import { ModLevelsService } from '@/services/api/mod-levels.service';
import { SelectButtonModule } from 'primeng/selectbutton';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FoundersSelectionsComponent } from './founder-selections.component';


@Component({
    selector: 'app-new-binder',
    imports: [
      ToastModule, 
      ButtonModule,
      ConfirmDialogModule,
      CommonModule,
      SelectModule,
      FormsModule,
      DialogModule,
      PlanFilterComponent,
      PlanBrowserComponent,
      PlanBadgeComponent,
      FoundersSelectionsComponent,
      SelectButtonModule,
      IconFieldModule,
      InputIconModule,
      InputTextModule,
    ],
    template: `
    <p-dialog [header]="header" [modal]="true" [visible]="true" [closable]="false">

    <div class="flex flex-col gap-4 mb-8" style="margin-bottom: 2rem;">
    <div class="grid grid-cols-12 gap-2">
        <label class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Client</label>
        <div class="col-span-12 md:col-span-9" *ngIf="clientService.clientData().length > 0">
            <div class="border-round shadow p-2 mb-1 text-left" style="border-radius: var(--border-radius);">
            <div class="flex">
            <i class="pi pi-user" *ngIf="clientService.clientData().length === 1" style="font-size: 2.5rem"></i>
            <i class="pi pi-users" *ngIf="clientService.clientData().length > 1" style="font-size: 2.5rem"></i>
      <div class="mr-0 md:mr-1 ml-1">
        <!-- <div class="block text-xl text-500 font-medium mb-1">{{ getPlanName() }}</div> -->
        <div class="block text-600 text-xl text-left font-bold mb-1">{{ clientService.getCombinedNames() }}</div>
        <div class="block text-400 text-left"></div>
      </div>
    </div>
            </div>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2">
        <label class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Office</label>
        <div class="col-span-12 md:col-span-9">
            <div class="text-900 w-full">
            <p-select 
            [options]="officesSig()" 
            [(ngModel)]="selectedOffice" 
            
            optionLabel="Title" 
            appendTo="body"
            placeholder="Select an office" 
            class="w-full" />
            </div>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2">
        <label class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Hubspot Deal</label>
        <div class="col-span-12 md:col-span-9">
        <p-select 
        [options]="dealsOptions()" 
        [(ngModel)]="selectedDeal" 
        optionLabel="properties.dealname" 
        appendTo="body"
        placeholder="Select a deal" 
        class="w-full" />
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2" *ngIf="!higharc">
        <label class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Binder Type</label>
        <div class="col-span-12 md:col-span-9">
        <p-selectbutton 
        [options]="binderTypes" 
        [allowEmpty]="false" 
        [(ngModel)]="binderType" 
        optionLabel="label" 
        optionValue="value" 
        aria-labelledby="basic" 
         [style]="{'width':'100%'}"
        class="w-full"/>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2" *ngIf="binderType === 'Higharc'">
        <label class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Higharc URL</label>
        <div class="col-span-12 md:col-span-9">
        <p-iconfield class="w-full">
    <input type="text" pInputText  [(ngModel)]="higharcUrl" (ngModelChange)="onUrlChange($event)" class="w-full" placeholder="Enter Higharc URL"/>
    <p-inputicon class="pi pi-spinner pi-spin" *ngIf="loadingUrl"/>
</p-iconfield>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-2">
        <label class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Plan</label>
        <div class="col-span-12 md:col-span-9">
                 <p-button [outlined]="true" class="w-full" [disabled]="higharcMode" (click)="openPlanBrowser()" [style]="{'width': '100%', 'text-align': 'left', 'justify-content': 'flex-start'}">
         <app-plan-badge [plan]="plansService.selectedPlan()"></app-plan-badge>
 </p-button>
        
        </div>
    </div>

    <div class="grid grid-cols-12 gap-2" *ngIf="!higharcMode">
        <label class="flex items-center col-span-12 mb-2 md:col-span-3 md:mb-0">Template</label>
        <div class="col-span-12 md:col-span-9">
        <p-select 
        [options]="binderTemplatesOptions()" 
        [(ngModel)]="selectedTemplate" 
        optionLabel="Description" 
        appendTo="body"
        placeholder="Select a template" 
        class="w-full" />
        </div>
    </div>
<app-founders-selections *ngIf="higharcMode"></app-founders-selections>
</div>

<ng-template #footer>
        <p-button label="Create Binder" (click)="onCreateBinder()" [disabled]="disableCreate()" />
    </ng-template>
</p-dialog>
<p-dialog [visible]="planFilterService.dialogOpen()" [modal]="true" [draggable]="false" [resizable]="false"
    [closeOnEscape]="true" [closable]="false" (onHide)="setDialogState(false)"
    [style]="{ 'min-width': '90vw', 'min-height':'90vh'}">
    <ng-template pTemplate="header">
        <app-plan-filter></app-plan-filter>
    </ng-template>
    <app-plan-browser></app-plan-browser>

</p-dialog>

    `
})
export class NewBinderComponent {
    private clientIdService = inject(ClientIdServiceService);
    public clientService = inject(ClientService);
    public officeService = inject(OfficesService);
    public dealsService = inject(DealsService);
    public planFilterService = inject(PlanFilterService);
    public higharcPlanService = inject(HigharcPlanService);
    public plansService = inject(PlansService);
    public officeTemplatesService = inject(OfficeTemplatesService);
    public binderService = inject(BinderService);
    public router = inject(Router);
    public modLevelsService = inject(ModLevelsService);
    private destroyRef = inject(DestroyRef);

    @Input() higharc: boolean = false;

    public officesSig = computed(() => this.officeService.getFilteredOffices('Binders', 'edit'));
public dealsOptions = computed(() => this.dealsService.getDeals());
public binderTemplatesOptions = computed(() => this.officeTemplatesService.filteredBinderTemplates());


    // selectedOffice: Franchise | null = null;
    selectedDeal: HsDeal | null = null;
    loading = false;
    higharcUrl: string = '';
    hsId: number | null = null;
    binderType: 'Higharc' | 'Standard' = 'Standard';
    binderTypes = [{label: 'Standard', value: 'Standard'},{label: 'Higharc', value: 'Higharc'}];
    loadingUrl = false;

    unlinkedMode = false
    constructor(
        
      ) {
        if(this.officeTemplatesService.binderTemplates().length === 0) {
          this.officeTemplatesService.getBinderTemplates();
        }

        effect(() => {
          const clientId = this.clientIdService.clientId();
          const hsId = this.clientIdService.hsId();
        
          if (clientId && clientId > 0) {
            this.clientService.getClient(clientId)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((data) => {
                // avoid tracking writes that could retrigger us
                untracked(() => {
                  this.clientService.transformBinderClientsData(data.clients, clientId, data.contacts);
                  this.dealsService.setDeals(data.deals);
                  if (data.Clients?.hsId) this.hsId = Number(data.Clients.hsId);
                });
              });
          } else if (hsId && hsId > 0) {
            this.unlinkedMode = true;
            this.hsId = hsId;
            this.clientService.getHsClient(hsId)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((data) => {
                untracked(() => {
                  this.clientService.transformBinderClientsData(data.clients, hsId, data.contacts);
                  this.dealsService.setDeals(data.deals);
                });
              });
          }
        }, { allowSignalWrites: true });

        effect(() => {
          const haPlan = this.higharcPlanService.haPlan();
          const plans = this.plansService.fullPlansList();
          if (!haPlan || !plans || plans.length === 0) return;
        
          const found = this.plansService.selectHighArcPlan(haPlan.studioDocId, haPlan.styleId);
          const alreadySelected = untracked(() => this.plansService.selectedPlan()?.PlanID === found?.PlanID);
          console.log('ha plan found:', haPlan);
          if (!found || alreadySelected) return;
        
          // commit without creating extra deps
          untracked(() => {
            this.plansService.setSelectedPlan(found);
            this.loadingUrl = false;
          });
        }, { allowSignalWrites: true });

        effect(() => {
          const office = this.officeService.selectedOffice();
          if (!office) return;
          untracked(() => {
            this.officeTemplatesService.setBinderFilter(office);
            this.officeTemplatesService.setFIDFilter(office);
          });
        }, { allowSignalWrites: true });        

        effect(() => {
          const plan = this.plansService.selectedPlan();
          if(plan) {
            console.log('plan mod level:', this.getModLevel());
          }
        });

      }

      get selectedOffice() {
        return this.officeService.selectedOffice();
      }

      get higharcMode() {
        return this.higharc || this.binderType === 'Higharc';
      }

      set selectedOffice(office: Franchise | null) {
        this.officeService.setSelectedOffice(office);
      }

      get offices() {
        return this.officeService.getFilteredOffices('Binders','edit')
      }

      get header() {
        return !this.clientService.clientData() || this.clientService.clientData().length === 0 || !this.clientService.clientData()[0].ClientLastName || this.clientService.clientData()[0].ClientLastName === null ? 'New Binder' : 'New ' + this.clientService.clientData()[0].ClientLastName + ' Binder'
    }

      get higharcPlan() {
        return this.higharcPlanService.haPlan();
      }

      set selectedTemplate(template: StandardTemplate | null) {
          this.officeTemplatesService.selectedTemplate.set(template);
      }

      get selectedTemplate() {
        return this.officeTemplatesService.selectedTemplate()
      }

      setDialogState(state: boolean) {
        this.planFilterService.setDialogOpen(state);
      }

      openPlanBrowser() {
        this.planFilterService.setDialogOpen(true);
      }

      onTemplateChange(template: StandardTemplate) {
        this.officeTemplatesService.selectedTemplate.set(template);
      }

      disableCreate() {
        return !this.selectedOffice || !this.selectedDeal || ((this.higharcMode || this.binderType === 'Higharc') && !this.higharcPlan) || (!(this.higharcMode || this.binderType === 'Higharc') && !this.selectedTemplate) || !this.plansService.selectedPlan() || this.loading;
      }

      getModId(plan: Plan | null) {
        if(!plan) {
          return 2;
        }
        if(plan.customPlan) {
          return 4;
        }
        else if(plan.Archived) {
          return 3;
        }
        return 2;
      }

      getModLevel() {
        const modId = this.getModId(this.plansService.selectedPlan() || null);
        return this.modLevelsService.modLevels().find(mod => mod.ModID === modId);
      }

      onCreateBinder() {
        if(this.higharcMode) {
          this.newHigharcBinder();
        }
        else {
          this.createBinder();
        }
      }

      onUrlChange(url: string) {
        const isvalid = url.includes('/') && url.includes('higharc');
        if (isvalid) {
          const urlParts = url.split('/');
          const builderIndex = urlParts.indexOf('builders') + 1;
          const planIndex = urlParts.indexOf('home-plans') + 1;
          const builderId = urlParts[builderIndex];
          const planId = urlParts[planIndex];
          if(builderId && planId) {
          console.log('builderId:', builderId, 'planId:', planId);
          this.higharcPlanService.getHigharcPlan(builderId, planId);
          }
        }
      }

      findHigharcPlan(planData: HigharcPlan) {
        const found = this.plansService.selectHighArcPlan(planData.studioDocId, planData.styleId);
        const alreadySelected = untracked(() => this.plansService.selectedPlan()?.PlanID === found?.PlanID);
        if (!found || alreadySelected) return;
        untracked(() => {
          this.plansService.setSelectedPlan(found);
          this.loadingUrl = false;
        });
      }

      newHigharcBinder() {
        console.log('Before creating binderData - haPlanId:', this.higharcPlan?.id); // Add this debug log

        const now = new Date();
const formattedDate = [
  String(now.getMonth() + 1).padStart(2, '0'),  // Month is 0-indexed
  String(now.getDate()).padStart(2, '0'),
  String(now.getFullYear()).slice(-2)           // Last two digits of year
].join('-');
        
        const binderData = {
  
          ClientID: this.unlinkedMode ? 0: this.clientService.primaryData()?.clientId,
          SelectedFID: this.selectedOffice?.FID,
          PlanID: Number(this.plansService.selectedPlan()?.PlanID),
          MainFID: Number(this.officeService.selectedOffice()?.FID),
          ClientLastName: this.clientService.primaryData()?.lastName,
          hsDeal: this.selectedDeal?.id,
          haId: this.higharcPlan?.id,  // This is where the value should be
          haBuilderId:  this.higharcPlan?.builderId,
          BinderTotal: this.higharcPlan?.totalPrice,
          OptionsTotal: this.higharcPlan?.optionsPrice,
          SQFT: this.higharcPlan?.totalFloorArea,
          PlanPrice: this.higharcPlan?.basePrice,
          Thumb: this.higharcPlan?.thumbnailUrl,
          Title: this.higharcPlan?.planName + '-' + formattedDate
        }
    
        console.log('haId value in binderData:', binderData.haId); // Add this debug log
        console.log('this.haPlanId() direct reference:', this.higharcPlan?.id); // Add this debug log
        console.log('binderData:', binderData);
    
        const planData = {
          optionSets: JSON.stringify(this.higharcPlan?.optionSets),
          planName: this.higharcPlan?.planName,
          thumbnailUrl: this.higharcPlan?.thumbnailUrl,
          haId: this.higharcPlan?.id,
          haCustomerId: this.higharcPlan?.customerId,
          masterplanId: this.higharcPlan?.masterPlanId,
          basePrice: this.higharcPlan?.basePrice,
          totalPrice: this.higharcPlan?.totalPrice,
          elevation: this.higharcPlan?.elevation,
          totalFloorArea: this.higharcPlan?.totalFloorArea,
          optionsPrice: this.higharcPlan?.optionsPrice
        }
    
        const templateId = this.selectedTemplate?.SSID || 0;
    
        const options = this.higharcPlanService.convertOptionSets();
        console.log('binderData:', binderData);
        this.binderService.createHigharcBinder(binderData, templateId, planData, options, this.hsId || 0).subscribe(
          newBinder => {
            this.loading = false;
            this.router.navigate(['app/binders/edit/'+newBinder.BinderID.toString()])
          }
        )
      }

      createBinder() {
        const now = new Date();
        const modLevel = this.getModLevel();
        let engineeringAssembly: any = null;
        const formattedDate = [
          String(now.getMonth() + 1).padStart(2, '0'),  // Month is 0-indexed
          String(now.getDate()).padStart(2, '0'),
          String(now.getFullYear()).slice(-2)           // Last two digits of year
        ].join('-');
        let binderData = {
        ClientID: this.unlinkedMode ? 0: this.clientService.primaryData()?.clientId,
        SelectedFID: this.selectedOffice?.FID,
          PlanID: Number(this.plansService.selectedPlan()?.PlanID),
          MainFID: Number(this.officeService.selectedOffice()?.FID),
          ClientLastName: this.clientService.primaryData()?.lastName,
          hsDeal: this.selectedDeal?.id,
          PlanPrice: this.plansService.selectedPlan()?.PlanPrices?.[0]?.BasePrice,
          Title: this.plansService.selectedPlan()?.PlanName + '-' + formattedDate,
          ModLevel: modLevel?.ModID
        }

        if(modLevel?.ModCost) {
          engineeringAssembly = {
            Price: modLevel?.ModCost,
            Quantity: 1,
            Description: 'Fee for extra Drafting and Engineering beyond standard.',
            CategoryID: 321,
            Name: 'Drafting Fee',
            Type: 'F'
          }
        }


    
        // console.log('create test:', binderData, this.selectedTemplateId);
        // console.log('create test:', this.selectedDealId, this.selectedPlan?.PlanID, this.officeService.selectedOffice()?.FID, this.hsId);
    
        this.binderService.createBinderFromTemplate(binderData, this.selectedTemplate?.SSID || 0, this.hsId || 0, engineeringAssembly).subscribe(
          newBinder => {
            this.loading = false;
            this.router.navigate(['app/binders/edit/'+newBinder.BinderID.toString()])
          }
        )
      }

}

